import axios from "axios";
import { useEffect, useState } from "react";
import { useHistory } from "react-router";
import { DASHBOARD_ROUTE } from "../../../../../routes";
import authServices from "../../../../../services/authServices";
import dataProvider from "../../../../../services/dataProvider";
import { FORMS_ROUTE } from "../../../dashboard-routes";
import FileUploadButton from "../input/file-upload-btn";
import downloadForm from "../download-form";
import { markTaskComplete } from "../../../common/mark-task-complete";
import getAssociatedTask from "../getAssociatedTask";
import AssociatedTask from "../../../common/associated-task";

const SG7ComplaintForm = ({ formType, formTitle }) => {
    const formPath = "Bucket2Forms/sg7-complaint-form.docx";

    const [successMsg, setSuccessMsg] = useState("");
    const [errorMsg, setErrorMsg] = useState("");
    const [isLoading, setIsLoading] = useState("");
    const [isDownloading, setIsDownloading] = useState(false);
    const [formState, setFormState] = useState({});
    const [associatedTask, setAssociatedTask] = useState(null);
    const [completeTask, setCompleteTask] = useState(true);
    const history = useHistory();
    const [isFetching, setIsFetching] = useState(true);

    useEffect(() => {
        getAssociatedTask("SG7ComplaintFormRegister")
            .then(function (res) {
                setIsFetching(false);
                // console.log("AT",res.data);
                if (res.data.length > 0) {
                    setAssociatedTask(res.data[0]);
                    // console.log(res.data[0]);
                }
            })
            .catch(function (error) {
                setIsFetching(false);
                console.error(error);
            });
    }, []);

    function setFile(file, field, setFormState) {
        setFormState((fs) => ({ ...fs, [field]: file }));
    }

    function handleSubmit() {
        var data = new FormData();
        let jsonData = {};
        setIsLoading(true);
        setSuccessMsg("");
        setErrorMsg("");

        data.append("formType", formType + "Register");
        data.append("formTitle", formTitle + " Register");
        data.append("dateRecieved", "");
        data.append("natureOfComplaint", "");
        data.append("licenseeSignature", "");
        data.append("actionTaken", "");
        jsonData["formType"] = formType;
        jsonData["formTitle"] = formTitle;

        for (var key in formState) {
            data.append(key, formState[key]);
            jsonData[key] = formState[key];
        }

        //console.log(jsonData);

        var config = {
            method: "post",
            url: dataProvider.baseUrl + "inlineForms-addInlineFormDetails",
            headers: {
                orgid: authServices.getOrgId(),
                token: authServices.getToken(),
            },
            data: data,
        };

        axios(config)
            .then(function (response) {
                // console.log("Inline Form Add", response.data);
                if (response.data.status === "success") {
                    if (completeTask && associatedTask) {
                        markTaskComplete(associatedTask.id)
                            .then(function (response) {
                                history.push(DASHBOARD_ROUTE + FORMS_ROUTE + "/bucket-1/sg7-complaint-form-register");
                            })
                            .catch(function (error) {
                                console.error(error);
                                setSuccessMsg("");
                                setErrorMsg("Unable To Complete Task");
                            });
                    } else {
                        setSuccessMsg("New Entry Recorded");
                    }
                    setSuccessMsg("New Entry Recorded");
                } else {
                    setErrorMsg("Something Went Wrong");
                }
                setIsLoading(false);
            })
            .catch(function (error) {
                console.error(error);
                setErrorMsg(error.message);
                setIsLoading(false);
            });
    }

    return (
        <div id="SG7ComplaintForm">
            <div className="container-fluid p-0">
                <div className="card p-4 m-0 no-radius border-0 border-bottom flex-row align-items-center">
                    <div>
                        <h5 className="m-0">{formTitle}</h5>
                    </div>
                    <div className="flex-fill"></div>

                    {isDownloading ? (
                        <button className="btn btn-primary text-white d-flex align-items-center" disabled>
                            Downloading
                            <div
                                className="spinner-border spinner-border-sm text-primary text-white ms-2"
                                role="status"
                            >
                                <span className="visually-hidden">Loading...</span>
                            </div>
                        </button>
                    ) : (
                        <button
                            onClick={() => {
                                downloadForm(formPath, formType, formTitle, setIsDownloading);
                            }}
                            className="btn btn-primary text-white"
                        >
                            Download Form
                        </button>
                    )}
                </div>
            </div>

            {successMsg && !errorMsg && (
                <div className="container-fluid py-0 mt-3 px-3">
                    <div className="alert alert-success m-0" role="alert">
                        {successMsg}
                    </div>
                </div>
            )}

            {errorMsg && (
                <div className="container-fluid py-0 mt-3 px-3">
                    <div className="alert alert-danger m-0" role="alert">
                        {errorMsg}
                    </div>
                </div>
            )}

            {associatedTask && (
                <div className="container-fluid py-0 mt-3 px-3">
                    <AssociatedTask
                        style={{ marginBottom: 0 }}
                        task={associatedTask}
                        completeTask={completeTask}
                        setCompleteTask={setCompleteTask}
                    />
                </div>
            )}

            {isFetching ? (
                <div className="container-fluid p-3">
                    <div className="card p-3">
                        <div className="">
                            <div className="d-flex align-items-center justify-content-center">
                                <div className="me-3">Fetching Form Data</div>
                                <div className="spinner-border text-primary" role="status">
                                    <span className="visually-hidden">Loading...</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            ) : (
                <div className="container-fluid p-3">
                    <div className="card p-3 py-5">
                        <h3 className="text-center mb-5">SG7 ComplaintForm File</h3>

                        <div className="row mx-auto w-100" style={{ maxWidth: "40rem" }}>
                            <div className="col-md-4 d-flex align-items-center">Upload Form :</div>
                            <div className="col-md">
                                <FileUploadButton
                                    file={formState["SG7ComplaintFormFile"]}
                                    setFile={setFile}
                                    field="SG7ComplaintFormFile"
                                    stateUpdateFunction={setFormState}
                                />
                            </div>
                            <div className="mt-4 d-flex justify-content-center">
                                {isLoading ? (
                                    <button
                                        className="d-flex align-items-center btn btn-primary text-light"
                                        disabled={true}
                                    >
                                        Submiting
                                        <div className="spinner-border spinner-border-sm ms-3" role="status">
                                            <span className="visually-hidden">Loading...</span>
                                        </div>
                                    </button>
                                ) : (
                                    <button className="btn btn-primary text-light" onClick={handleSubmit}>
                                        Submit
                                    </button>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default SG7ComplaintForm;
